var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isDestinationLandingPage
        ? _c(
            "ul",
            { staticClass: "booking__type mb--2" },
            _vm._l(_vm.sectionList, function (item) {
              return _c(
                "li",
                { key: item.key, staticClass: "booking__type-item" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.activeSection,
                        expression: "activeSection",
                      },
                    ],
                    staticClass: "checkmark",
                    attrs: {
                      type: "radio",
                      id: item.id,
                      autocomplete: "off",
                      name: "hotel-active-section",
                    },
                    domProps: {
                      value: item.value,
                      checked: _vm._q(_vm.activeSection, item.value),
                    },
                    on: {
                      change: function ($event) {
                        _vm.activeSection = item.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: item.id } }, [
                    _vm._v(" " + _vm._s(item.title)),
                  ]),
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isExternalHotelActive ? _c("external-hotel-search-box") : _vm._e(),
      _vm._v(" "),
      _vm.isInternalHotelActive ? _c("internal-hotel-search-box") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }